import React from "react";
import Layout from "../layouts/Auth";
import Stepper from "../components/steppers/Stepper";
import VerifyEmail from "../parts/SignUp/VerifyEmail";
import SignUpContext, { SignUpContextProvider } from "../contexts/signUp";
import useScroll from "../hooks/useScroll";
import useScript from "../hooks/useScript";

// Steps
import Step1 from "../parts/UserForm/Account";
import StepDesigner2 from "../parts/UserForm/AboutMe";
import StepDesigner3 from "../parts/UserForm/LocationSocials";
import StepEntrepreneur2 from "../parts/UserForm/AboutStartup";
import StepEntrepreneur3 from "../parts/UserForm/Social";
import StepEntrepreneur4 from "../parts/UserForm/WhatYouDo";
import StepUniversity from "../parts/UserForm/University";

const GOOGLE_RECAPTCHA_SCRIPT =
  "https://www.google.com/recaptcha/api.js?render=6Ld6nL4UAAAAAOwPByKNLFptHKtgckCtWKf0gE8C";

const steps = {
  designer: [Step1, StepDesigner2, StepDesigner3],
  company: [Step1, StepEntrepreneur2, StepEntrepreneur3, StepEntrepreneur4],
  university: [
    Step1,
    StepEntrepreneur2,
    StepEntrepreneur3,
    StepEntrepreneur4,
    StepUniversity,
  ],
};

const SignUp = () => {
  useScript(GOOGLE_RECAPTCHA_SCRIPT);
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const [sent, setSent] = React.useState(false);
  const { data = {}, setData, send, loading } = React.useContext(SignUpContext);
  const flow = React.useMemo(() => getFlow(data), [
    data?.role,
    data?.ecosystem,
  ]);
  const Step = steps[flow] ? steps[flow][currentIndex] : Step1;
  const [errors, setError] = React.useReducer(reduceError, []);
  const { freeScroll } = useScroll();
  freeScroll();

  const next = async () => {
    if (currentIndex >= steps[flow].length - 1) {
      const result = await send();
      if (result.code === 200) setSent(true);
      else setError(result);
    } else {
      setCurrentIndex(currentIndex + 1);
      window.scrollTo(0, 0);
    }
  };

  if (sent)
    return (
      <Layout withLogin width="640px" title="Sign up">
        <VerifyEmail />
      </Layout>
    );

  return (
    <Layout withLogin title="Sign up">
      <div className="pSignUp">
        <Stepper
          current={currentIndex}
          setCurrent={setCurrentIndex}
          count={getStepCount(data)}
        />
        <Step
          data={data}
          setData={setData}
          errors={errors}
          setError={setError}
          next={next}
          loading={loading}
          signUp
        />
        {errors && errors.length > 0 && (
          <ul className="pSignUp_error">
            {errors.map((err, index) => (
              <li key={index}>{err.message}</li>
            ))}
          </ul>
        )}
      </div>
    </Layout>
  );
};

const reduceError = (state, action) =>
  action ? [...state, { ...action }] : [];

const getFlow = data => {
  if (data["role"] === "designer") return "designer";
  else if (data["ecosystem"]) return "university";
  else return "company";
};

const getStepCount = data => {
  const flow = getFlow(data);
  if (flow === "designer") return 3;
  else if (flow === "university") return 5;
  else return 4;
};

export default props => (
  <SignUpContextProvider>
    <SignUp {...props} />
  </SignUpContextProvider>
);
